export default __webpack_public_path__ + "static/media/Lojas_on.9eb114b8.svg";